import { gql } from "@apollo/client";
import CommonFragments from "features/common/fragments";
import Fragments from "../../gql/fragments/fragments";

export const PAGED_INDIVIDUAL_PARTNERS_QUERY = gql`
  query pagedIndividualPartners($pager: PagerInput, $filters: IndividualPartnerFilterInput) {
    pagedIndividualPartners(pager: $pager, filters: $filters) {
      pagination(pager: $pager, filters: $filters) {
        ...pagination
      }
      values {
        ...individualPartner
      }
    }
  }
  ${CommonFragments.pagination}
  ${Fragments.individualPartner}
`;

export const PAGED_LEGAL_PARTNERS_QUERY = gql`
  query pagedLegalPartners($pager: PagerInput, $filters: LegalPartnerFilterInput) {
    pagedLegalPartners(pager: $pager, filters: $filters) {
      pagination(pager: $pager, filters: $filters) {
        ...pagination
      }
      values {
        ...legalPartner
      }
    }
  }
  ${CommonFragments.pagination}
  ${Fragments.legalPartner}
`;

export const CITIZENSHIP_QUERY = gql`
  query citizenships($search: String) {
    citizenships(search: $search) {
      id
      name
    }
  }
`;

export const LEGAL_FORMS_QUERY = gql`
  query legalForms {
    legalForms {
      legalFormId
      legalFormName
    }
  }
`;

export const CITIES_DICTIONARY_QUERY = gql`
  query cities($parentId: Int) {
    cities(parentId: $parentId) {
      cityId
      cityName
      parentId
    }
  }
`;

export const COUNTIES_DICTIONARY_QUERY = gql`
  query counties($parentId: Int) {
    counties(parentId: $parentId) {
      districtId
      districtName
      parentId
    }
  }
`;

export const COUNTRIES_DICTIONARY_QUERY = gql`
  query countries {
    countries {
      countryId
      countryName
    }
  }
`;
